import { FeatureCheckerService, PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService,
        private _featureCheckerService:FeatureCheckerService
    ) {
    }
    getMenu(): AppMenu {
        return new AppMenu("MainMenu", "MainMenu", [
            new AppMenuItem("Dashboard", "Pages.Administration.Host.Dashboard", "icon-dash", AppRoutes.admin.hostDashboard),
            new AppMenuItem("Dashboard", "Pages.Tenant.Dashboard", "icon-dash", AppRoutes.dashboard, undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.DashBoardInEdition');}),
            new AppMenuItem("Tenants", "Pages.Tenants", "icon-tenant", AppRoutes.admin.tenants),

            new AppMenuItem("Editions", "Pages.Editions", "icon-editions", AppRoutes.admin.editions),

            new AppMenuItem("Trial Request", "Pages.Tenants", "icon-trial-request", AppRoutes.admin.trialTenant),
            new AppMenuItem("Clients", "Pages.Clients", "icon-client", AppRoutes.clients, undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.ClientEdition');}),
            new AppMenuItem("Projects", "Pages.Projects", "icon-project", AppRoutes.projects, undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.ProjectInEdition');}),
            new AppMenuItem("Leaves", "Pages.TimeOff", "icon-Calendar", AppRoutes.leaves, undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeOffEdition');}),

            new AppMenuItem(
                "Activities",
                "",
                "icon-activities",
                "",
                [],
                [
                    new AppMenuItem(
                        "RealTimeTracking",
                        "Pages.Activity.ReamTimeTracking",
                        "icon-Real-Time-Tracking",
                        AppRoutes.activitiesRealTimeTracking
                        , undefined, undefined, undefined,undefined, () => {
                            return this._featureCheckerService.isEnabled('App.RealTimeTracking');}),
                    new AppMenuItem("Time and Attendance", "Pages.Activity.TimeAndAttendence", "icon-Time-Attendance", AppRoutes.activitiesTimeAndAttendance, undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.Timeandattendence');}),
                    new AppMenuItem("Apps and Websites", "Pages.Activity.AppAndWebSites", "icon-Apps-Websites", AppRoutes.activitiesAppsAndWebsites, undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.AppAndWebsite');}),
                    new AppMenuItem("Screenshots", "Pages.Activity.ScreenShots", "icon-Screenshots", AppRoutes.activitiesScreenshots, undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.Screenshot');}),
                    new AppMenuItem("Live Streaming", "Pages.Activity.liveStreaming.View", "icon-live-streaming", AppRoutes.activitiesLiveScreenshots, undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.LiveStreaming');}),

                ]
            , undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.ActivitiesEdition');}),
            new AppMenuItem("TimeTracking", "Pages.TimeSheet", "icon-TimeTrack", AppRoutes.timeTracking, undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeTrackingEdition');}),
                 new AppMenuItem("Timesheet", "Pages.TimeSheet", "icon-TimeSheet", AppRoutes.timesheet, undefined, undefined, undefined, undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeSheetEdition');
            }),

             new AppMenuItem("Reports", "Pages.Reports", "icon-reports", AppRoutes.reports
             , undefined, undefined, undefined,undefined, () => {
               return this._featureCheckerService.isEnabled('App.ReportEdition');}),
            new AppMenuItem('Subscription', 'Pages.Administration.Tenant.SubscriptionManagement', 'icon-subscription', AppRoutes.admin.subscriptionManagement),
            new AppMenuItem(
                "Administration",
                "Pages.Administration",
                "icon-admin1",

                "",
                [],
                [
                    new AppMenuItem("Roles", "Pages.Administration.Roles", "icon-admin-roles", AppRoutes.admin.roles),
                    new AppMenuItem("MemberAllocation", "Pages.Administration.MemberAllocation", "icon-admin-roles", AppRoutes.admin.memberAllocation),
                    new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', AppRoutes.admin.languages),
                    new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', AppRoutes.admin.auditLogs),
                    new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', AppRoutes.admin.maintenance),
                    new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-medical', AppRoutes.admin.uiCustomization),
                    new AppMenuItem('WebhookSubscriptions', 'Pages.Administration.WebhookSubscription', 'flaticon2-world', AppRoutes.admin.webhookSubscriptions),
                    new AppMenuItem('DynamicProperties', 'Pages.Administration.DynamicProperties', 'flaticon-interface-8', AppRoutes.admin.dynamicProperty),
                    new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', AppRoutes.admin.hostSettings),
                    new AppMenuItem("AttendanceReportDistribution", "Pages.Administration", "icon-admin-roles", AppRoutes.admin.attendanceReportDistribution, undefined, undefined, undefined, undefined, () => !!this._appSessionService.tenantId),
                ]
            ),
            new AppMenuItem('ProxyLogin', 'Pages_SuperAdmin.Impersonate.user', 'icon-superadmin', AppRoutes.admin.superAdmin)
        ]);
    }

    /** Horizontal top navigation for host (Super Admin) users. */
    getSuperAdminTopBarMenu(): AppMenu {
        return new AppMenu('SuperAdminTopBar', 'SuperAdminTopBar', [
            new AppMenuItem('Dashboard', 'Pages.Administration.Host.Dashboard', 'icon-dash', AppRoutes.admin.hostDashboard),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'icon-tenant', AppRoutes.admin.tenants),
            new AppMenuItem('Editions', 'Pages.Editions', 'icon-editions', AppRoutes.admin.editions),
            new AppMenuItem('Trial Request', 'Pages.Tenants', 'icon-trial-request', AppRoutes.admin.trialTenant),
            new AppMenuItem(
                'Administration',
                'Pages.Administration',
                'icon-admin1',
                '',
                [],
                [
                    new AppMenuItem('Roles', 'Pages.Administration.Roles', 'icon-admin-roles', AppRoutes.admin.roles),
                    new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', AppRoutes.admin.languages),
                    new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', AppRoutes.admin.auditLogs),
                    new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', AppRoutes.admin.maintenance),
                    new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-medical', AppRoutes.admin.uiCustomization),
                    new AppMenuItem('WebhookSubscriptions', 'Pages.Administration.WebhookSubscription', 'flaticon2-world', AppRoutes.admin.webhookSubscriptions),
                    new AppMenuItem('DynamicProperties', 'Pages.Administration.DynamicProperties', 'flaticon-interface-8', AppRoutes.admin.dynamicProperty),
                    new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', AppRoutes.admin.hostSettings),
                ]
            ),
        ]);
    }

    /** Top navigation for tenant users with the Super Admin role. */
    getTenantSuperAdminTopBarMenu(): AppMenu {
        return new AppMenu('TenantSuperAdminTopBar', 'TenantSuperAdminTopBar', [
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'icon-dash', AppRoutes.dashboard, undefined, undefined, undefined, undefined, () => {
                return this._featureCheckerService.isEnabled('App.DashBoardInEdition');
            }),
            new AppMenuItem('ProxyLogin', 'Pages_SuperAdmin.Impersonate.user', 'icon-superadmin', AppRoutes.admin.superAdmin),
            new AppMenuItem(
                'Administration',
                'Pages.Administration',
                'icon-admin1',
                '',
                [],
                [
                    new AppMenuItem('Roles', 'Pages.Administration.Roles', 'icon-admin-roles', AppRoutes.admin.roles),
                    new AppMenuItem('MemberAllocation', 'Pages.Administration.MemberAllocation', 'icon-admin-roles', AppRoutes.admin.memberAllocation),
                    new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', AppRoutes.admin.languages),
                    new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', AppRoutes.admin.auditLogs),
                    new AppMenuItem('Settings', 'Pages.Administration.Tenant.Settings', 'flaticon-settings', AppRoutes.tenantSettings),
                ]
            ),
        ]);
    }

    isTenantSuperAdminUser(): boolean {
        const roles = this._appSessionService.user?.userRole ?? AppConsts.userRoleArray ?? [];
        return roles.some(r => (r ?? '').toLowerCase() === 'super admin');
    }

    shouldUseSuperAdminTopNavigation(): boolean {
        return false;
    }

    shouldHideHeaderBreadcrumbs(): boolean {
        return !this._appSessionService.tenantId || this.isTenantSuperAdminUser();
    }

    getSuperAdminTopNavigationMenu(): AppMenu {
        return this._appSessionService.tenantId
            ? this.getTenantSuperAdminTopBarMenu()
            : this.getSuperAdminTopBarMenu();
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === "" || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }
        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === "Pages.Administration.Tenant.SubscriptionManagement" &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }

}
